import { ProjectStatusE } from "../../../models/enums";
import { UnfinishedDeliveryT } from "../models";

export default (item: UnfinishedDeliveryT): string => {
    if (!item) return 'transparent';
    if (item?.projectStatus === ProjectStatusE.Opened) return 'Pending upload files';
    if (item?.projectStatus === ProjectStatusE.WaitingForApprovalOfPostProduction) return 'Pending approval';
    return 'Pending payment'
    return '';
};